import { Button } from "@mui/material"
import Popup from "../../components/Popup"
import RedSpinner from "../../components/loaders/RedSpinner"
import { useDispatch, useSelector } from "react-redux";
import { closeDeleteSavedReceiverPopup, deleteSavedReceiver, selectDeleteSavedReceiverPopup, selectSavedReceiversErrors, selectSavedReceiversStatuses } from "./savedReceiversSlice";
import { useEffect } from "react";
import { pushAlert } from "../alerts/alertSlice";
import { useTranslation } from "react-i18next";


const DeleteSavedReceiverPopup = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const popupState = useSelector(selectDeleteSavedReceiverPopup);
    const savedReceiversStatuses = useSelector(selectSavedReceiversStatuses);
    const savedReceiversErrors = useSelector(selectSavedReceiversErrors);

    const handleDeleteButtonClick = () => {
        dispatch(deleteSavedReceiver(popupState.savedReceiverID));
    }

    const closePopup = () => {
        dispatch(closeDeleteSavedReceiverPopup());
    }

    useEffect(() => {
        if (savedReceiversStatuses.deleting === "fulfilled") {
            dispatch(closeDeleteSavedReceiverPopup());
        }
    }, [dispatch, savedReceiversStatuses.deleting])

    useEffect(() => {
        if (savedReceiversErrors.deleting) {
            dispatch(pushAlert({
                message: t(savedReceiversErrors.deleting),
                type: "danger",
                delay: 2000,
            }));
        }
    }, [dispatch, savedReceiversErrors.deleting])

    return (
        <Popup opened={popupState.opened} closeCallback={closePopup}>
            <div style={{
                height: "5vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <Button
                    variant="contained"
                    sx={{
                        color: "white",
                        bgcolor: "#dc2626",
                        fontSize: "0.7rem",
                        ":hover": {
                            bgcolor: "#b91c1c",
                        },
                    }}
                    onClick={handleDeleteButtonClick}
                >
                    {t("saved_receivers.delete_saved_receiver")} 
                    {savedReceiversStatuses.deleting === "pending" && 
                        <span className="">
                            <RedSpinner width={20} height={20}/>
                        </span>}
                </Button>
            </div>
        </Popup>
  )
}

export default DeleteSavedReceiverPopup